module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/functions/training-certificate/training-certificate-grid/training-certificate-grid.component.css
// module id = ./src/app/pages/functions/training-certificate/training-certificate-grid/training-certificate-grid.component.css
// module chunks = main